export default __webpack_public_path__ + "static/media/shape4.ba5b05d8.svg";